import { Injectable } from '@angular/core';
import { FirestoreRepo } from '../firestore-repo.service';
import { EnvelopeConfigModel } from '@models/e-signing';
import { CollectionPaths } from '@models/collections';
import { select } from '@ngxs/store';
import { SelectedMatter } from '../../state/matter/matter.selectors';
import { BusinessState } from '../../state/business';

interface EnvelopeConfigParams {
	matterId: string;
	businessId: string;
}

@Injectable({ providedIn: 'root' })
export class EnvelopeConfigRepo extends FirestoreRepo<
	EnvelopeConfigModel,
	EnvelopeConfigParams
> {
	matterId_ = select(SelectedMatter.id);
	businessId_ = select(BusinessState.businessId);

	constructor() {
		super((pathParams) =>
			CollectionPaths.business_matter_envelope_config(
				pathParams?.businessId || this.businessId_(),
				pathParams?.matterId || this.matterId_(),
			),
		);
	}
}
